export const GRADE_ADVANCEMENT_HYPOTHESIS_ID = 'id';
export const GRADE_ADVANCEMENT_HYPOTHESIS = 'gradeAdvancementHypothesis';
